const jquery = require("jquery");
const bootstrap = require("bootstrap");

window.$ = window.jQuery = jquery;
window.bootstrap = bootstrap;